export default class FreelancerInvoiceContactEditItem {
  constructor(item) {
    this.OfficeId = item.OfficeId;
    this.DqContacts = item.DqContacts.map((x) => x.userId);
    this.RmContacts = item.RmContacts.map((x) => x.userId);
    this.KamContacts = item.KamContacts.map((x) => x.userId);
    this.BiContacts = item.BiContacts.map((x) => x.userId);
    this.BdContacts = item.BdContacts.map((x) => x.userId);
    this.HrContacts = item.HrContacts.map((x) => x.userId);
    this.ItContacts = item.ItContacts.map((x) => x.userId);
    this.MarketingContacts = item.MarketingContacts.map((x) => x.userId);
    this.FinanceContacts = item.FinanceContacts.map((x) => x.userId);
  }
}
